import { req } from 'react-reqq-lite';

export const setIsLoading = (method, key, value) => {
  req.set(`LOADING/${method}/${key}`, value);
};
